import { createImageVariantConfig } from './sdkLoader';

/**
 * The listing image variants to ask Sharetribe for (`imageVariant.*` query params): the
 * marketplace's listing card at 400px and 800px wide, in its aspect ratio.
 */
export const getListingImageVariants = listingImageConfig => {
  const { aspectWidth = 1, aspectHeight = 1, variantPrefix = 'listing-card' } =
    listingImageConfig || {};
  const aspectRatio = aspectHeight / aspectWidth;

  return {
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
  };
};
